<div [formGroup]="group">
  <py-checkbox-slider
    [addMargin]="addMargin"
    [leftLabel]="leftLabel"
    [rightLabel]="rightLabel"
    [rightMargin]="rightMargin"
    [centerLabel]="centerLabel"
    [tooltip]="tooltip"
    [labelClass]="labelClass"
  >
    <input
      type="checkbox"
      [formControlName]="fieldName"
      [attr.disabled]="disabled || null"
      [attr.aria-describedby]="ariaDescribedBy"
    />
  </py-checkbox-slider>
</div>
